<template>
  <div class="grid meeting-agenda">
    <div v-if="loaders.agendas" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div v-if="agendas && currentAgenda">
      <div class="grid">
        <div class="grid__col--12 meeting-agenda__title h-center-align">{{ currentAgenda.title }}</div>
      </div>
      <div class="grid">
        <div class="grid__col--12 meeting-agenda__sub-title h-center-align">{{ currentAgenda.meeting_date }}</div>
      </div>
      <div class="panel grid meeting-agenda__detail-container h-flex-container">
        <div class="grid__col--5 meeting-agenda__description-section h-flex-item" v-if="currentAgenda.description !== ''">
          <div class="meeting-agenda__description">
            <div class="meeting-agenda__item-title">Description</div>
            <div class="meeting-agenda__item-content" v-html="currentAgenda.description"></div>
          </div>
        </div>
        <div class="grid__col--2--half" v-else></div>
        <div class="grid__col--7 h-no-margin">
          <div class="grid h-flex-container">
            <div class="grid__col--3 meeting-agenda__attendees-section h-flex-item">
              <div class="meeting-agenda__attendees-list">
                <div class="meeting-agenda__item-title">Attendees</div>
                <div class="meeting-agenda__item-content" v-for="(contact, index) in contactAttendeesList">{{ contact.name }}</div>
              </div>
            </div>
            <div class="grid__col--3 meeting-agenda__attendees-section h-flex-item">
              <div class="meeting-agenda__attendees-list">
                <div class="meeting-agenda__item-title">Fuel Attendees</div>
                <div class="meeting-agenda__item-content" v-for="(fuelUser, index) in fuelUserAttendeesList">{{ fuelUser.name }}</div>
              </div>
            </div>
            <div class="grid__col--3 meeting-agenda__attendees-section h-flex-item">
              <div class="meeting-agenda__attendees-list">
                <div class="meeting-agenda__item-title">Other Attendees</div>
                <div class="meeting-agenda__item-content" v-for="(other, index) in otherAttendeesList">{{ other.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid__col--2--half" v-if="currentAgenda.description === ''"></div>
      </div>
    </div>
    <AgendaContainer v-if="agendas" :agenda="currentAgenda"></AgendaContainer>
    <AgendaItemModal v-if="modalActive"></AgendaItemModal>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import AgendaContainer from '../meeting-agendas/AgendaContainer.vue';
  import AgendaItemModal from '../meeting-agendas/AgendaItemModal.vue';

  export default {
    name: 'MeetingAgendaLayout',
    components: {
      MoonLoader,
      AgendaContainer,
      AgendaItemModal,
    },
    data() {
      return {
        commentFetcher: null,
      };
    },
    computed: {
      ...mapGetters('meetingAgendas', [
        'loaders',
        'agendas',
        'currentAgenda',
        'fuelUserAttendeesList',
        'contactAttendeesList',
        'otherAttendeesList',
        'modalActive',
        'autoFetchCommentsTimeout',
        'attendeeID',
      ]),
      ...mapGetters('main', ['meetingAttendee']),
      ...mapGetters('auth', ['attendee']),
      agenda() {
        return this.currentAgenda;
      },
    },
    beforeMount() {
      if (this.meetingAttendee) {
        if (!lodash.map(this.attendee.permissions, 'url').includes(this.$route.path.replace(/^\//, ''))) {
          this.$store.dispatch('flash/addMessage', { type: 'error', text: 'Redirecting: You don\'t have access to that area of the member Portal.' })
          this.$router.push(`/${lodash.map(this.attendee.permissions, 'url')[0]}`);
        }
      }
      this.commentFetcher = setInterval(() => this.fetchComments(), this.autoFetchCommentsTimeout);
    },
    beforeDestroy() {
      clearTimeout(this.commentFetcher);
    },
    async mounted() {
      this.$store.dispatch('meetingAgendas/setProperty', { key: 'currentAgendaID', value: parseInt(this.$route.params.id) });
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
      if (!this.agendas) {
        if (this.attendeeID) {
          await this.$store.dispatch('meetingAgendas/getAgenda');
        } else {
          await this.$store.dispatch('meetingAgendas/getAgendas');
        }
      }
    },
    methods: {
      fetchComments() {
        this.$store.dispatch('meetingAgendas/fetchComments');
      },
    },
  };
</script>
